<template>
  <v-dialog
    v-model="showDialog"
    :max-width="component?.name === 'GainedContactDetails' ? '95%' : 1250"
    persistent
    style="margin-bottom: 50px"
    :fullscreen="$vuetify.display.smAndDown"
  >
    <component
      :is="component.details"
      :component-value="componentValue"
      @close-details="emit('close-details')"
    >
      <template #header>
        <v-card-title class="pa-0">
          <v-toolbar
            color="primary"
            dark
            flat
          >
            <v-toolbar-title>{{ t(component.title) }}</v-toolbar-title>
            <v-spacer />
            <v-toolbar-items>
              <v-btn
                icon
                @click="emit('close-details')"
              >
                <v-icon
                  size="large"
                  class="text-white font-weight-bold"
                >
                  mdi-close
                </v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
        </v-card-title>
      </template>

      <template #footer>
        <v-card-actions>
          <v-spacer />
          <v-btn
            variant="text"
            color="grey-darken-3"
            @click="emit('close-details')"
          >
            {{ t('labels.cancel') }}
          </v-btn>
          <div class="spacer" />
        </v-card-actions>
      </template>
    </component>
  </v-dialog>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'

import contactAcquisitionDetails from '@/modules/dashboard/dashboardDetails/contactAcquisitionDetails.vue'
import emailFunnelsDetails from '@/modules/dashboard/dashboardDetails/emailFunnelsDetails.vue'
import gainedContactsDetails from '@/modules/dashboard/dashboardDetails/gainedContactsDetails.vue'
import impressionsDetails from '@/modules/dashboard/dashboardDetails/impressionsDetails.vue'

const { t } = useI18n()
const props = defineProps({
  componentValue: {
    type: Array,
    default: () => [],
  },
  component: {
    type: String,
    default: 'contactAcquisitionDetails',
  },
})

const showDialog = ref(true)
const emit = defineEmits(['close-details'])
const component = computed(() => {
  return {
    contactAcquisitionDetails: {
      title: 'dashboard.details.contact-acquisition.dialog.title',
      details: contactAcquisitionDetails,
      name: 'ContactAcquisitionDetails',
    },
    impressionsDetails: {
      title: 'dashboard.details.impressions.dialog.title',
      details: impressionsDetails,
      name: 'ImpressionsDetails',
    },
    emailFunnelsDetails: {
      title: 'dashboard.details.email-funnels.dialog.title',
      details: emailFunnelsDetails,
      name: 'EmailFunnelsDetails',
    },
    gainedContactsDetails: {
      title: 'dashboard.details.gained-contacts.dialog.title',
      details: gainedContactsDetails,
      name: 'GainedContactDetails',
    },
  }[props.component]
})
</script>
<style scoped>
.spacer {
  margin-bottom: 0;
}
@media (max-width: 1450px) {
  .spacer {
    margin-bottom: 80px;
  }
}
</style>
